"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styles = require("../common/styles/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function LegendBar(props) {
  var activityDetails = props.activityDetails,
    selectedActivities = props.selectedActivities,
    setSelected = props.setSelected,
    _props$width = props.width,
    width = _props$width === void 0 ? 300 : _props$width,
    _props$showLegendItem = props.showLegendItems,
    showLegendItems = _props$showLegendItem === void 0 ? true : _props$showLegendItem;
  var maxActivities = Math.ceil(width / 150);
  var _useState = (0, _react.useState)(0),
    page = _useState[0],
    setPage = _useState[1];
  var maxPage = Math.ceil(activityDetails.length / maxActivities);
  var ifActivitySelected = function ifActivitySelected(activity) {
    return selectedActivities.findIndex(function (selected) {
      return selected.key === activity.key;
    }) >= 0;
  };
  var handleClick = function handleClick(selectedActivity) {
    ifActivitySelected(selectedActivity) ? setSelected(selectedActivities.filter(function (activity) {
      return activity.key !== selectedActivity.key;
    })) : setSelected(selectedActivities.concat([selectedActivity]));
  };
  if (!showLegendItems) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_styles.LegendRow, null, activityDetails.slice(page * maxActivities, (page + 1) * maxActivities).map(function (activity) {
    return /*#__PURE__*/_react["default"].createElement(_styles.LegendWrapper, {
      key: activity.key,
      selected: ifActivitySelected(activity),
      onClick: function onClick() {
        return handleClick(activity);
      }
    }, /*#__PURE__*/_react["default"].createElement(_styles.ColorBlock, {
      color: activity.color
    }), /*#__PURE__*/_react["default"].createElement(_styles.LegendText, {
      "data-testid": "ActivitiesChart.Legend." + activity.key
    }, activity.name));
  }), /*#__PURE__*/_react["default"].createElement(_styles.LegendWrapper, {
    selected: activityDetails.length > maxActivities,
    style: {
      alignSelf: "flex-end"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: "caret-left",
    onClick: function onClick() {
      return page > 0 && setPage(page - 1);
    }
  }), activityDetails.length > maxActivities && page + 1 + "/" + maxPage, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: "caret-right",
    onClick: function onClick() {
      return page + 1 < maxPage && setPage(page + 1);
    }
  })));
}
var _default = exports["default"] = LegendBar;